const HPGeoStates = {
    whitelist: {
        California: 6,
        Kansas: 20,
        Missouri: 29,
        Florida: 12,
    },
    blacklist: {
        Tennessee: 47,
        Arizona: 4,
        Texas: 48,
    },
};

export default HPGeoStates;



// WEBPACK FOOTER //
// ./src/app/config/app.geoStates.config.js